import styled from '@emotion/styled';

export const BrandCatalogContainer = styled.div`
  width: 100%;
  padding-top: var(--sizes-50);
`;
